import { useApiClient } from '../../hooks/useApiClient';
import { BuilderAnalysisType } from '../../types/SimilarlySituated/BuilderAnalysisType.type';
import { BuilderBox } from '../../types/SimilarlySituated/BuilderBox.type';
import { BuilderBoxAnalysesPayload } from '../../types/SimilarlySituated/BuilderBoxAnalysis.type';
import { BuilderBoxUpdate } from '../../types/SimilarlySituated/BuilderBoxCreate.type';

export const useBuilderBoxApi = () => {
  const apiClient = useApiClient();

  return {
    getBuilderBoxById: (builderBoxId: number): Promise<BuilderBox> => {
      return apiClient(`/builder_boxes/${builderBoxId}`);
    },

    updateBuilderBox: (builderBoxId: number, updateData: BuilderBoxUpdate): Promise<BuilderBox> => {
      return apiClient(`/builder_boxes/${builderBoxId}`, {
        method: 'PATCH',
        body: JSON.stringify(updateData),
      });
    },

    deleteBuilderBox: (builderBoxId: number): Promise<void> => {
      return apiClient(`/builder_boxes/${builderBoxId}`, {
        method: 'DELETE',
      });
    },

    getAnalysisTypes: (builderBoxId: number): Promise<BuilderAnalysisType[]> => {
      return apiClient(`/builder_boxes/${builderBoxId}/analysis_types`);
    },

    createAnalyses: (builderBoxId: number, payload: BuilderBoxAnalysesPayload): Promise<BuilderBox> => {
      return apiClient(`/builder_boxes/${builderBoxId}/analyses`, {
        method: 'POST',
        body: JSON.stringify(payload),
      });
    },

    updateAnalyses: (builderBoxId: number, payload: BuilderBoxAnalysesPayload): Promise<BuilderBox> => {
      return apiClient(`/builder_boxes/${builderBoxId}/analyses`, {
        method: 'PATCH',
        body: JSON.stringify(payload),
      });
    },
  };
};
